<template>
    <div class="col-md-9">
        <h1 class="pages__title">Location</h1>
        <div class="pages__box">
            <div class="form">
                <ValidationObserver ref="form">

                    <LogoAvatarUploader
                        :label="'logo'"
                        :logo="location.logo"
                        :upload-handler="uploadImage"
                        @update-image="updateLogo"
                    />

                    <ValidationProvider
                        class="form-group mb-3"
                        name="Title"
                        v-slot="{ errors }"
                        rules="required"
                    >
                        <label for="" class="form-label">Branch title</label>
                        <input
                            type="text"
                            v-model="location.title"
                            class="form-control pl-4"
                        >
                        <FormError :error="errors[0]" name="Title"></FormError>
                    </ValidationProvider>
                    <ValidationProvider
                        class="form-group mb-3"
                        name="Address"
                        v-slot="{ errors }"
                        rules="min:3"
                    >
                        <label for="" class="form-label">Address</label>
                        <input
                            type="text"
                            v-model="location.address"
                            class="form-control pl-4"
                        >
                        <FormError :error="errors[0]" name="Address"></FormError>
                    </ValidationProvider>


                    <BaseButtons
                        :on-cancel="backToPreviousPage"
                        :on-save="validateForm"
                    />

                </ValidationObserver>
            </div>
        </div>
    </div>
</template>

<script>

import {defineComponent} from "vue";
import BaseButtons from "../../Common/BaseButtons.vue";
import FormError from "../../Common/FormError.vue";
import ModalHandler from "../../../mixins/ModalHandler";
import AdminPanelService from "../../../services/AdminPanelService";
import LogoAvatarUploader from "../../Common/ContentFields/LogoAvatarUploader.vue";

export default defineComponent({
    name: 'LocationEditor',
    mixins: [ModalHandler],
    components: {LogoAvatarUploader, FormError, BaseButtons},
    props: {
        locationId: Number
    },
    data() {
        return {
            location: {
                logo: null,
                title: null,
                address: null,
            },
        }
    },
    methods: {
        updateLogo(result) {
            this.location.logo = result
        },
        async uploadImage(formData) {
            return await AdminPanelService.uploadLogo(formData)
        },
        async getLocationInfo() {
            try {
                const { data : response} = await AdminPanelService.getLocationInfo(this.locationId)
                this.location = response
            } catch (error) {
                console.error(error)
            }
        },
        async validateForm() {
            this.$showLoadingMessage('Please wait and do not close the page — the address is being saved.')
            const valid = await this.$refs.form.validate();

            if (!valid) {
                this.$showValidationErrorMessage();
                return;
            }

            if (this.locationId) {
                await this.updateLocationInfo()
            } else {
                await this.createLocation()
            }
        },

        async createLocation() {
            try {
                await AdminPanelService.createLocation(this.location)
                this.$showSuccessMessage('The information was saved')
            } catch (e) {
                console.error(e)
            }
        },
        async updateLocationInfo() {
            try {
                await AdminPanelService.updateLocationInfo(this.locationId, this.location)
                this.$showSuccessMessage('The information was updated')
            } catch (e) {
                console.error(e)
            }
        }
    },
    mounted() {
        if( this.locationId) {
            this.getLocationInfo()
        }
    }
})
</script>



<style scoped>

</style>
